import Flex from "../../../shared/components/Flex";
import useDevice from "../../../shared/hooks/useDevice";
import { useAppSelector } from "../../../shared/store/store";
import styles from "./css/SensorStatusMobileFloating.module.css";
import Text from "../../../shared/components/Text";
import statusToColor from "../utils/statusToColor";
import { useEffect, useState } from "react";
import useSensorStatus from "../hooks/useSensorStatus";

interface SensorStatusMobileFloatingProps {
    isStatusBoardOpen: boolean;
}

type LegendItem = {
    label: string;
    count: number;
    color: string;
};

function SensorStatusMobileFloating({ isStatusBoardOpen }: SensorStatusMobileFloatingProps) {
    const device = useDevice();
    const sensorDashboardFilter = useAppSelector(state => state.sensorDashboard.filter);
    const { items } = useSensorStatus();
    const [legendItems, setLegendItems] = useState<LegendItem[]>([]);

    useEffect(() => {
        const next = [
            { codeName: "지도합계", label: "전체" },
            { codeName: "안전", label: "안전" },
            { codeName: "주의", label: "주의" },
            { codeName: "경보", label: "경보" },
            { codeName: "점검", label: "점검" },
        ].map(({ codeName, label }) => {
            const found = items.find(item => item.codeName === codeName);
            return {
                label,
                count: found?.statusCnt ?? 0,
                color: statusToColor(codeName).color,
            };
        });
        setLegendItems(next);
    }, [items, sensorDashboardFilter]);

    // 데스크톱에서만 표기, StatusBoard 열려 있으면 숨김
    if (device !== "desktop" || isStatusBoardOpen) return null;

    return (
        <div className={styles.container}>
            <Flex
                flexDirection="column"
                gap={10}
                style={{
                    background: "#ffffff",
                    borderRadius: 14,
                    boxShadow: "0 8px 24px rgba(0,0,0,0.14)",
                    padding: "14px 16px",
                    minWidth: 170,
                }}
            >
                <Text size={"13px"} weight={"bold"} color="#444">제품현황</Text>
                <Flex flexDirection="column" gap={8}>
                    {legendItems.map((item) => (
                        <Flex
                            key={item.label}
                            alignItems="center"
                            justifyContent="space-between"
                            style={{
                                background: "rgba(0,0,0,0.02)",
                                border: "1px solid rgba(0,0,0,0.1)",
                                borderRadius: 10,
                                padding: "10px 12px",
                            }}
                        >
                            <Flex alignItems="center" gap={10}>
                                <span
                                    style={{
                                        width: 14,
                                        height: 14,
                                        borderRadius: 7,
                                        backgroundColor: item.color,
                                        display: "inline-block",
                                    }}
                                />
                                <Text size={"12px"} weight={"bold"} color="#222">
                                    {item.label}
                                </Text>
                            </Flex>
                            <Text size={"12px"} weight={"bold"} color="#111313">
                                {item.count}
                            </Text>
                        </Flex>
                    ))}
                </Flex>
            </Flex>
        </div>
    );
}

export default SensorStatusMobileFloating;
